import { App } from 'vue'
import { Auth0Plugin, Auth0PluginOptions, initializePlugin } from './Auth0Plugin'

// TODO: need error route in config
export const InstallAuth0Plugin = {
  install(app: App, options: Auth0PluginOptions): void {
    initializePlugin(app, options)
  }
}

export { Auth0Plugin as Auth0Plugin }
export * from './Auth0Plugin'
